import { useRef as s, useEffect as f } from "react";
var l = function l(e) {
    var n = typeof e == "function",
      t = s(e);
    f(function () {
      t.current = e;
    }), f(function () {
      if (n) {
        var o = function o(r) {
          var u = t.current(r);
          if (typeof u == "string") return r.preventDefault(), r.returnValue = u;
          if (r.defaultPrevented) return r.returnValue = "";
        };
        return window.addEventListener("beforeunload", o), function () {
          window.removeEventListener("beforeunload", o);
        };
      }
    }, [n]);
  },
  a = function a(_ref) {
    var _ref$children = _ref.children,
      e = _ref$children === void 0 ? null : _ref$children,
      n = _ref.onBeforeunload;
    return l(n), e;
  };
export { a as Beforeunload, l as useBeforeunload };